(() => {
  const DEFAULTS = {
    selector: '.lb-match',
    claim: '.lb-claim',
    prize: '55% Off',
    decoys: ['10% Off', '20% Off', 'Free Ship'], // almeno 2, diversi dal premio
    pattern: 'WDWW',   // ordine dei reveal: W = premio, D = esca. Il 3° W fa vincere
    cards: 9,
    cols: 3,
    backLabel: '?',
    revealRest: true,  // a fine gioco gira le carte rimaste (con esche)
    autoClaim: false,  // true = clicca da solo .lb-claim dopo la vittoria
    winDelay: 700
  };
  const CFG = Object.assign({}, DEFAULTS, window.LB_MATCH || {});

  const st = document.createElement('style');
  st.textContent = `
.lb-match{--lb-accent:0 126 64;--lb-fg:#fff;--lb-back-bg:#fff;--lb-w:72px;--lb-h:108px;--lb-r:12px;--lb-gap:12px}
.lb-grid{display:grid;grid-template-columns:repeat(var(--lb-cols,3),var(--lb-w));gap:var(--lb-gap);justify-content:center;margin:16px auto 0}
.lb-card{width:var(--lb-w);height:var(--lb-h);perspective:1000px;cursor:pointer;border-radius:var(--lb-r);outline:none;transition:transform .18s,filter .3s,opacity .3s;-webkit-tap-highlight-color:transparent}
.lb-card:not(.lb-on):hover{transform:translateY(-3px)}
.lb-card:focus-visible{box-shadow:0 0 0 3px rgb(var(--lb-accent)/.4)}
.lb-in{position:relative;width:100%;height:100%;border-radius:inherit;transform-style:preserve-3d;-webkit-transform-style:preserve-3d;transition:transform .5s}
.lb-on .lb-in{transform:rotateY(180deg)}
.lb-back,.lb-face{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;box-sizing:border-box;border-radius:inherit;border:2px solid rgb(var(--lb-accent));backface-visibility:hidden;-webkit-backface-visibility:hidden;overflow:hidden;text-align:center;font-weight:700;line-height:1.1}
.lb-back{background:var(--lb-back-bg);color:rgb(var(--lb-accent));font-size:32px}
.lb-face{background:rgb(var(--lb-accent));color:var(--lb-fg);font-size:17.6px;padding:4px;transform:rotateY(180deg)}
.lb-on,.lb-done .lb-card{cursor:default}
.lb-win{animation:lb-pulse 1.2s ease-in-out infinite}
.lb-dim{opacity:.4;filter:grayscale(.6)}
@keyframes lb-pulse{0%,100%{transform:scale(1)}50%{transform:scale(1.07)}}`;
  document.head.appendChild(st);

  // stato condiviso: sopravvive ai re-render di Klaviyo
  const S = { faces: Array(CFG.cards).fill(''), open: [], won: false, final: false, use: {}, dc: 0 };
  const roots = new Set();
  const mounted = new WeakSet();
  const pool = CFG.decoys.filter(x => x !== CFG.prize);

  const pickDecoy = () => {
    for (let i = 0; i < pool.length; i++) {
      const v = pool[(S.dc + i) % pool.length];
      if ((S.use[v] || 0) < 2) { S.use[v] = (S.use[v] || 0) + 1; S.dc++; return v; }
    }
    return pool[S.dc++ % pool.length] || ''; // mai 3 esche uguali finché ce ne sono abbastanza
  };

  const setClaim = (root, show) =>
    (root.closest('form') || document).querySelectorAll(CFG.claim).forEach(b => {
      if (CFG.autoClaim) b.style.setProperty('display', 'none', 'important');
      else b.style.visibility = show ? 'visible' : 'hidden';
    });

  function paint(root) {
    root.querySelectorAll('.lb-card').forEach((c, i) => {
      const f = S.faces[i], on = !!f;
      c.classList.toggle('lb-on', on);
      c.querySelector('.lb-face').textContent = f;
      c.tabIndex = on || S.won ? -1 : 0;
      c.setAttribute('aria-pressed', String(on));
      c.setAttribute('aria-label', on ? f : 'Scegli questa carta');
      c.classList.toggle('lb-win', S.final && f === CFG.prize);
      c.classList.toggle('lb-dim', S.final && f !== CFG.prize);
    });
    root.classList.toggle('lb-done', S.won);
    setClaim(root, S.final);
  }
  const renderAll = () => roots.forEach(r => (r.isConnected ? paint(r) : roots.delete(r)));

  function finish() {
    if (CFG.revealRest) S.faces.forEach((f, i) => { if (!f) S.faces[i] = pickDecoy(); });
    S.final = true;
    renderAll();
    if (CFG.autoClaim) {
      const r = [...roots].find(x => x.isConnected);
      const b = r && (r.closest('form') || document).querySelector(CFG.claim);
      b && setTimeout(() => b.click(), CFG.claimDelay || 1500);
    }
  }

  function flip(i) {
    if (S.won || S.faces[i]) return;
    const t = (CFG.pattern[S.open.length] || 'W').toUpperCase();
    S.faces[i] = t === 'W' || !pool.length ? CFG.prize : pickDecoy();
    S.open.push(i);
    renderAll();
    if (S.open.filter(j => S.faces[j] === CFG.prize).length >= 3) {
      S.won = true;
      renderAll();
      setTimeout(finish, CFG.winDelay);
    }
  }

  function build(root) {
    root.innerHTML = '';
    const g = document.createElement('div');
    g.className = 'lb-grid';
    g.style.setProperty('--lb-cols', CFG.cols);
    for (let i = 0; i < CFG.cards; i++) {
      const c = document.createElement('div');
      c.className = 'lb-card';
      c.setAttribute('role', 'button');
      c.innerHTML = '<div class="lb-in"><div class="lb-back"></div><div class="lb-face"></div></div>';
      c.querySelector('.lb-back').textContent = CFG.backLabel;
      c.addEventListener('click', () => flip(i));
      c.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flip(i); }
      });
      g.appendChild(c);
    }
    root.appendChild(g);
    roots.add(root);
    paint(root);
  }

  function scan() {
    const els = document.querySelectorAll(CFG.selector);
    els.forEach(el => { if (!mounted.has(el)) { mounted.add(el); build(el); } });
    return els.length > 0;
  }
  function tryMount(n = 0) { if (!scan() && n < 30) setTimeout(() => tryMount(n + 1), 200); }

  window.addEventListener('klaviyoForms', e => {
    const t = e.detail && e.detail.type;
    if (t === 'open' || t === 'embedOpen' || t === 'stepSubmit') setTimeout(tryMount, 50);
  });
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', () => tryMount())
    : tryMount();
})();